

























































































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

import {
  emitFormChangeEvent,
  FormChangeEvent,
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import Confirmation from '@/components/Confirmation.vue';
import { LoadingService } from '@/services/loadingService';
import { Snotify } from '@/snotify/Snotify';
import ConfirmacionEliminar from '@/reusable/Mantenedor/ConfirmacionEliminar.vue';

import { AlertaGrilla } from '@/pantallas/Camaras/Alertas/fetchAlerta';
import { MnsajeNuevo } from '@/pantallas/CopilotoVirtual/Mensaje/mensaje';
import { fetchVariables } from '@/pantallas/CopilotoVirtual/Mensaje/fetchVariables';
import { OperacionesCrud } from '../../../reusable/Mantenedor/mantenedorUtils';
import MarkerClusterer, { ClusterIconStyle } from '@google/markerclustererplus';

@Component({
  components: {
    FormFieldsContainer,
    Confirmation,
    ConfirmacionEliminar,
  },
})
export default class AlertaCamaraForm extends Vue {
  @Prop({ default: false }) isVerDetalle: boolean;
  @Prop({ required: false }) alertaSeleccionado: AlertaGrilla;
  @Prop({ default: false }) esEditar: boolean;

  /* state */

  isFormValid: boolean = false;
  //vVariables: Variables[] = [];
  files: any[] = [];

  mostrarConfirmacionEliminar: boolean = false;
  mostrarDatos: boolean = false;
  mostrarModalCrear: boolean = false;
  mostrarModalEditar: boolean = false;

  icono: any = {};
  iconoUrl = '';
  iconoBase64: string = '';
  nombre: string = '';
  mensaje: string[] = ['* Ya existe un Mensaje con este nombre.'];
  hint: string = '';
  estado: boolean = true;
  seleccionEstado: number = 0;
  urlzoom: string = '';

  show_zoom: boolean = false;
  current_zoom: number = 1;
  min_zoom: number = 1;
  max_zoom: number = 5;
  imagezoom_width: string = '100%';

  modalCrudActivo: OperacionesCrud = null;

  map: google.maps.Map;
  /* misc */

  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  formFields: FormFieldDefMap = {
    fechaAlarma: {
      label: 'fechaAlarma',
      id: 'fechaAlarma',
      value: '',
    },
    codVehiculo: {
      label: 'codVehiculo',
      id: 'codVehiculo',
      value: '',
    },
    codFlota: {
      label: 'codFlota',
      id: 'codFlota',
      value: '',
    },
    flota: {
      label: 'Flota',
      id: 'flota',
      value: '',
    },
    numActividad: {
      label: 'numActividad',
      id: 'numActividad',
      value: '',
    },
    alerta: {
      label: 'Alerta',
      id: 'alerta',
      value: '',
    },
    tipoAlerta: {
      label: 'Tipo Alerta',
      id: 'tipoAlerta',
      value: '',
    },
    patente: {
      label: 'Patente',
      id: 'patente',
      value: '',
    },
    velocidad: {
      label: 'Velocidad',
      id: 'velocidad',
      value: '',
    },
    latitud: {
      label: 'Latitud',
      id: 'latitud',
      value: '',
    },
    longitud: {
      label: 'Longitud',
      id: 'longitud',
      value: '',
    },
    files: {
      label: 'files',
      id: 'files',
      value: '',
    },
  };

  mounted() {
    const validator = makeValidatorDictionary(this.formFields);
    this.$validator.localize('es', validator);
    this.handleSeleccionadoChange();
  }

  handleCrearClick() {
    this.$validator.errors.clear();
    this.mostrarModalCrear = true;
  }
  handleCierraModalSinGuardar() {
    this.mostrarModalCrear = false;
    this.mostrarModalEditar = false;
  }

  async handleCierreModalBtnGuardar(e: FormChangeEvent) {
    this.mostrarModalCrear = false;
  }
  async handleCierreModalBtnGuardarEditar(e: FormChangeEvent) {}

  cerrarModalCrud() {
    this.modalCrudActivo = null;
  }

  get isConfirmacionEliminarActivo() {
    return this.modalCrudActivo === OperacionesCrud.eliminar;
  }

  @Watch('alertaSeleccionado', { deep: true })
  async handleSeleccionadoChange() {
    if (!this.alertaSeleccionado) {
      return;
    }
    //this.formFields.alerta.value = this.alertaSeleccionado.alerta;
    this.formFields.patente.value = this.alertaSeleccionado.patente;
    this.formFields.tipoAlerta.value = this.alertaSeleccionado.tipoAlerta;

    let ubicacion = null;
    if (this.alertaSeleccionado.ubicacion.indexOf('null') == -1) {
      ubicacion = this.alertaSeleccionado.ubicacion.split(',');
      this.formFields.latitud.value = ubicacion[0];
      this.formFields.longitud.value = ubicacion[1];
    } else {
      this.formFields.latitud.value = 'Sin registro';
      this.formFields.longitud.value = 'Sin registro';
    }

    if (this.alertaSeleccionado.files != '') {
      this.files = JSON.parse(this.alertaSeleccionado.files);
    }

    if (ubicacion != null) {
      let lat1 = parseFloat(ubicacion[0]);
      let lon1 = parseFloat(ubicacion[1]);
      document.getElementById('mapContainer').innerHTML = '';
      this.map = new google.maps.Map(document.getElementById('mapContainer'), {
        center: { lat: lat1, lng: lon1 },
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        gestureHandling: 'greedy',
        mapTypeControl: false,
        maxZoom: 20,
        minZoom: 2,
        zoom: 12,
      });
      let iconourl =
        'http://www.clker.com/cliparts/v/G/a/3/i/a/map-marker-th.png';
      let icon = {
        url: iconourl,
        scaledSize: new google.maps.Size(32, 51),
      };
      var marker = new google.maps.Marker({
        map: this.map,
        position: { lat: lat1, lng: lon1 },
        icon: icon,
        //animation: google.maps.Animation.DROP
      });
    } else {
      document.getElementById('mapContainer').innerHTML = 'Sin ubicación';
    }
  }

  @Watch('$validator.errors.items.length')
  handleErrorsChange() {
    this.emitFormChange();
  }

  @Watch('formFields', { deep: true })
  handleFormChange() {
    this.emitFormChange();
  }

  emitFormChange() {
    emitFormChangeEvent(
      this.$emit.bind(this),
      {
        entity: {
          fechaAlarma: this.formFields.fechaAlarma.value,
          fechaIngreso: '',
          codVehiculo: this.formFields.codVehiculo.value,
          codFlota: null,
          flota: this.formFields.flota.value,
          patente: this.formFields.patente.value,
          numActividad: this.formFields.numActividad.value,
          velocidad: this.formFields.velocidad.value,
          tipoAlerta: this.formFields.tipoAlerta.value,
          tipoAlertaOriginal: '',
          evidencia: '',
          ubicacion:
            this.formFields.latitud.value +
            ',' +
            this.formFields.longitud.value,
          files: this.formFields.files.value,
          grupo: '',
        } as AlertaGrilla,
      },
      this
    );
  }

  fetchVariables() {
    this.loadingService.showLoading();
    return fetchVariables()
      .catch(() =>
        this.$snotify.error(
          'Ha ocurrido un error al intentar obtener las variables',
          { timeout: 3000 }
        )
      )
      .finally(() => this.loadingService.hideLoading());
  }

  constructor() {
    super();
  }
  created() {
    this.cambio();
    this.files = [];
    if (this.alertaSeleccionado.files != '') {
      this.files = JSON.parse(this.alertaSeleccionado.files);
    }
  }

  cambio() {
    this.$emit('estadoSwitch', this.estado);
  }

  zoom(url: string) {
    this.urlzoom = url;
    this.show_zoom = true;
  }
  update_zoom() {
    if (this.current_zoom > this.max_zoom) {
      this.current_zoom = this.max_zoom;
    }
    if (this.current_zoom < this.min_zoom) {
      this.current_zoom = this.min_zoom;
    }
    this.imagezoom_width = 80 + 20 * this.current_zoom + '%';
  }
  zoom_in() {
    this.current_zoom = this.current_zoom + 1;
    this.update_zoom();
  }
  zoom_out() {
    this.current_zoom = this.current_zoom - 1;
    this.update_zoom();
  }
  zoom_close() {
    this.show_zoom = false;
    this.urlzoom = '';
  }
  download_img(url: string) {
    const a = document.createElement('a');
    a.href = `${process.env.VUE_APP_SERVICIO_MS}track/view?download=SI&url=${btoa(url)}`;
    a.download = url.split('/').pop();
    a.classList.add('urldownload');
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    a.remove();
  }
  handlerContexTmenu(e: any) {
    e.preventDefault();
  }
}
